import { Draggable } from "@hello-pangea/dnd";
import { noop } from "neetocist";

import Element from "./Element";

const ElementContainer = ({
  index,
  isDragDisabled,
  element,
  disabledElementTooltip,
  isCreatable,
  onSelect,
  isDraggingOver,
  isAddingNewElement,
  setVisiblePanel,
}) => {
  const isCreatableElement = isCreatable(element.value);

  if (isDragDisabled) {
    return (
      <Element
        {...{
          ...element,
          disabledElementTooltip,
          isAddingNewElement,
          isDragDisabled,
          setVisiblePanel,
        }}
        isCreatable={isCreatableElement}
        onClick={() => onSelect(element)}
      />
    );
  }

  return (
    <Draggable
      {...{ index }}
      draggableId={element.value}
      key={element.label}
      isDragDisabled={
        isDragDisabled || !isCreatableElement || isAddingNewElement
      }
    >
      {(provided, snapshot) => (
        <>
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...provided.draggableProps.style,
              ...(!snapshot.isDragging && { transform: "none" }),
            }}
          >
            <Element
              {...{
                ...element,
                disabledElementTooltip,
                isAddingNewElement,
                isDragDisabled,
                isDraggingOver,
                setVisiblePanel,
              }}
              isCreatable={isCreatableElement}
              onClick={() => onSelect(element)}
            />
          </div>
          {snapshot.isDragging && (
            <Element
              disabledElementTooltip={null}
              {...{ ...element, isAddingNewElement, setVisiblePanel }}
              isCreatable={false}
              onClick={noop}
            />
          )}
        </>
      )}
    </Draggable>
  );
};

export default ElementContainer;
